export const buttonThemes = {
  nav_red: {
    background: 'var(--app-red)',
    color: '#fff',
    labelWidth: 'auto'
  },
  nav_black: {
    background: '#000',
    color: '#fff',
    labelAlign: 'start'
  },
  nav_gray: {
    background: 'var(--app-light-gray)',
    color: '#000',
    borderRight: '1px solid #000',
    labelAlign: 'start',
    maxWidth: '100px',
  },
  nav_light: {
    color: 'var(--app-custom-gray)',
  },

  units: {
    labelWidth: 'auto',
    color: 'var(--app-medium-gray)',
  },

  buttonGroupDef: {
    labelAlign: 'center',
    labelWidth: '100%',
    background: 'transparent',
    height: '34px',
    checked: 'var(--app-red)',
    unchecked: 'var(--app-light-gray)'
  },

  buttonGroupBig: {
    iconSize: '50px',
  },

  buttonGroupBigNav: {
    iconSize: '38px',
    width: '40px',
    justify: 'start'
  },

  furnitureGroup: {
    iconSize: '90px',
    checked: 'none',
    unchecked: 'none',
  },

  furnitureGroupNav: {
    iconSize: '50px',
    checked: 'none',
    unchecked: 'none',
  },

  deviceGroup: {
    iconSize: '50px',
    checked: 'none',
    unchecked: 'none',
  },

  acousticGroup: {
    width: '82px',
    size: '16px',
    checked: 'var(--app-red)',
    unchecked: 'var(--app-light-gray)',
    label_checked: '#fff',
    label_unchecked: 'var(--app-medium-gray)',
    uppercase: true
  },

  acousticGroupNav: {
    width: '64px',
    height: '32px',
    size: '12px',
    checked: 'var(--app-red)',
    unchecked: 'var(--app-light-gray)',
    label_checked: '#fff',
    label_unchecked: 'var(--app-medium-gray)',
    uppercase: true,
    borderRadius: '4px'
  },

  familyGroup: {
    width: '200px',
    size: '44px',
    checked: 'var(--app-red)',
    unchecked: 'var(--app-light-gray)',
    label_checked: '#fff',
    label_unchecked: 'var(--app-medium-gray)',
  },

  navGroup: {
    iconScale: 1.2,
    justify: 'start',
    checked: 'var(--app-red)',
    unchecked: '#fff',
    label_checked: '#fff',
    label_unchecked: 'var(--app-medium-gray)',
  },

  actionGroup: {
    background: 'transparent',
    height: '36px',
    width: '64px',
    checked: 'var(--app-red)',
    unchecked: 'var(--app-medium-gray)',
    iconScale: '1.2'
  },

  dotGroup: {
    height: '8px',
    maxWidth: '8px',
    maxHeight: '8px',
    border: '4px',
    radius: '50%',
  }
}

export const iconThemes = {
  'door_move': {
    'icon_stroke': 'var(--app-dark-gray)',
    'icon_fill': 'var(--app-dark-gray)',
  },
  'button_selected': {
    'border_stroke': 'var(--app-dark-gray)',
    'border_fill': 'var(--app-red)',
    'icon_stroke': '#fff',
    'icon_fill': '#fff',
    border: '1px solid var( --app-dark-gray)',
  },

  'button_active': {
    'border_stroke': 'var(--app-red)',
    'border_fill': 'var(--app-light-gray)',
    'icon_stroke': 'var(--app-dark-gray)',
    'icon_fill': ' var(--app-dark-gray)',
    border: '1px solid transparent'
  },

  'button_disabled': {
    'border_stroke': 'var(--app-medium-gray)',
    'border_fill': 'var(--app-medium-gray)',
    'icon_stroke': '#fff',
    'icon_fill': '#fff',
  },

  'button_disabled-dim': {
    'border_stroke': 'var(--app-custom-gray)',
    'border_fill': 'var(--app-custom-gray)',
    'icon_stroke': '#fff',
    'icon_fill': '#fff',
  },

  'nav_active': {
    'border_stroke': 'none',
    'border_fill': 'none',
    'icon_stroke': '#fff',
    'icon_fill': '#fff',
  },

  'nav_inactive': {
    'border_stroke': 'none',
    'border_fill': 'none',
    'icon_stroke': 'var(--app-medium-gray)',
    'icon_fill': 'var(--app-medium-gray)',
  },

  'coverage_active': {
    'border_stroke': 'var(--app-red)',
    'border_fill': 'var(--app-red)',
    'icon_stroke': '#fff',
    'icon_fill': '#fff',
    'color': 'var(--app-red)'
  },

  'coverage_inactive': {
    'border_stroke': 'var(--app-medium-gray)',
    'border_fill': 'var(--app-medium-gray)',
    'icon_stroke': '#fff',
    'icon_fill': '#fff',
  },

  'furniture_active': {
    'border_stroke': 'var(--app-red)',
    'border_fill': 'var(--app-red)',
    'icon_stroke': 'var(--app-dark-gray)',
  },
  
  'furniture_inactive': {
    'border_stroke': 'var(--app-medium-gray)',
    'border_fill': 'none',
    'icon_stroke': 'var(--app-medium-gray)',
  },

  'device_selected': {
    'border_stroke': 'var(--app-dark-gray)',
    'border_fill': 'var(--app-red)',
    'icon_stroke': '#fff',
    'icon_fill': '#fff',
    border: '1px solid transparent',
  },

  'acoustic_inactive': {
    border: '1px solid var(--app-dark-gray)',
  },

  'acoustic_nav_active': {
    border: '1px solid var(--app-dark-gray)',
    background: 'var(--app-dark-gray)',
    color: '#fff'
  },

  'acoustic_nav_inactive': {
    border: '1px solid var(--app-dark-gray)',
    background: 'var(--app-light-gray)',
    color: 'var(--app-medium-gray)'
  },

  'dot_selected': {
    background: 'var(--app-red)',
  },
  
  'dot_active': {
    background: 'var(--app-light-gray)',
  }
}

export const modalThemes = {
  splash: {
    labelAlign: 'start',
    labelWidth: '28%',
    lineHeight: '32px',
  },
  default: {
    headerPadding: '16px 24px',
    headerBackground: '#000',
    headerColor: '#fff',
    background: '#fff',
    bodyPadding: '24px 24px 0px 24px',
    labelAlign: 'start',
    labelWidth: 'auto',
    inputBackground: 'var(--app-light-gray)',
    footerBackground: 'var(--app-light-gray)',
  },
  tutorial: {
    headerPadding: '16px 24px',
    headerBackground: '#fff',
    headerColor: '#000',
    headerAlign: 'center',
    headerBorder: 'var(--app-light-gray)',
    background: '#fff',
    bodyPadding: '24px 24px 0px 24px',
    footerBackground: 'var(--app-light-gray)',
    footerMargin: '0.5rem!important'
  },
  modern: {
    headerPadding: '24px 32px 20px',
    headerBackground: '#fff',
    headerColor: '#1a1a1a',
    headerAlign: 'left',
    headerBorder: '#e0e0e0',
    background: '#fff',
    color: '#333',
    bodyPadding: '0 32px 24px',
    footerBackground: '#fff',
    footerPadding: '20px 32px 24px',
    footerBorder: '#e0e0e0',
    borderRadius: '12px',
    boxShadow: '0 10px 40px rgba(0,0,0,0.15)'
  },
  requestQuote: {
    headerPadding: '24px 32px 16px',
    headerBackground: '#fff',
    headerColor: '#000',
    headerAlign: 'left',
    headerBorder: false,
    background: '#fff',
    color: '#333',
    bodyPadding: '0 32px 24px',
    footerBackground: '#fff',
    footerPadding: '24px 32px 40px',
    footerBorder: false,
    borderRadius: '8px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
  },
  loading: {
    headerPadding: '0px',
    headerBackground: 'transparent',
    headerColor: 'transparent',
    headerBorder: false,
    background: '#fff',
    color: '#333',
    footerBackground: 'transparent',
    footerPadding: '0px',
    footerBorder: false,
    borderRadius: '12px',
    boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
    opacity: 1,
    minWidth: '300px'
  }
};